var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("ies-form-field", { attrs: { field: _vm.field } }, [
    _vm._v("\n    " + _vm._s(this.field.value) + "\n"),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }